(function () {
  /* Upakarna Wishlist, custom, first-party, localStorage-backed.
     Wires up:
       - the existing .pc-wish heart button on every product card (data-pc-wish-id)
       - the PDP heart button next to the category eyebrow (also data-pc-wish-id,
         but carries its own explicit data-pc-wish-title/-url/-image/-price/-variant
         attributes since it isn't sitting inside a .pc card, see itemFromButton)
       - the header wishlist icon + count bubble (#upk-wishlist-toggle / #upk-wishlist-bubble)
       - a slide-out drawer (snippets/upk-wishlist-drawer.liquid) listing saved items,
         each with Add to bag + Buy it now
       - a Recently Viewed rail at the bottom of the drawer, reusing the SAME
         'upkRecent' localStorage key that assets/upk-rails.js already writes to
         from every PDP visit, no separate tracking needed.
     No app, no network calls beyond the standard /cart/add.js endpoint.

     Click handling notes: the delegated listener runs on the CAPTURE phase and
     calls stopImmediatePropagation() for wishlist-heart clicks specifically, so
     no other click handler on the card (navigation, quick view, etc.) can run
     first or interfere. The clicked button's own visual state is also flipped
     synchronously, in addition to the full syncButtons() sweep, so the exact
     heart tapped updates immediately, not on a following click. */

  var STORAGE_KEY = 'upk_wishlist_v1';
  var RECENT_KEY = 'upkRecent';
  // Real cart total (paise) required before checkout is allowed, kept in
  // sync with the same threshold used in snippets/cart-drawer.liquid,
  // sections/main-cart-footer.liquid and assets/upk-pdp.js.
  var UPK_MIN_ORDER_PAISE = (typeof window.UPK_MIN_ORDER_PAISE === 'number') ? window.UPK_MIN_ORDER_PAISE : 15000; /* OPEN-ITEMS 128 (D37): ₹150 after discounts; below it, Buy it now lands on the cart page with the gate */

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(id) {
    return getList().some(function (i) { return String(i.id) === String(id); });
  }
  function count() { return getList().length; }

  function remove(id) {
    saveList(getList().filter(function (i) { return String(i.id) !== String(id); }));
    afterChange();
  }
  function add(item) {
    var list = getList();
    if (!list.some(function (i) { return String(i.id) === String(item.id); })) {
      list.unshift(item);
      saveList(list);
    }
    afterChange();
  }
  function toggle(item) {
    if (has(item.id)) remove(item.id); else add(item);
  }

  function afterChange() {
    syncButtons();
    syncBubble();
    renderDrawer();
    document.dispatchEvent(new CustomEvent('upk:wishlist:change', { detail: { count: count() } }));
  }

  function syncBubble() {
    var bubble = document.getElementById('upk-wishlist-bubble');
    var countEl = document.getElementById('upk-wishlist-count');
    var n = count();
    if (countEl) countEl.textContent = n;
    if (bubble) bubble.style.display = n > 0 ? 'flex' : 'none';
  }

  function applyBtnState(btn, active) {
    btn.classList.toggle('liked', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.innerHTML = active ? '&#9829;' : '&#9825;';
  }

  function syncButtons() {
    document.querySelectorAll('[data-pc-wish-id]').forEach(function (btn) {
      applyBtnState(btn, has(btn.getAttribute('data-pc-wish-id')));
    });
  }

  /* Prices can arrive wrapped in markup, the currency-converter app embed
     rewrites the shop money format to <span class=cvc-money>…</span>, which then
     lands verbatim inside data-pc-wish-price. Strip any tags so we only ever
     store/render the plain "₹ 999" text. Applied on read AND render so items
     already saved with markup are cleaned up too. */
  function stripTags(s) {
    return String(s == null ? '' : s).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* Parses a raw data-pc-wish-price-cents attribute value into a number.
     Returns null when absent/unparseable so callers can fall back cleanly
     instead of mistaking "no data" for "zero". */
  function parsePriceCents(raw) {
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  /* Fallback-only ₹0 guard, used solely for wishlist items saved BEFORE this
     fix that have no stored priceCents at all, parses the formatted price
     TEXT and treats "no digits left, or exactly zero" as unavailable. This is
     no longer the primary purchase-eligibility source: it was found to be
     unreliable for products (e.g. Band+Charm Builder listings) whose product
     card shows a merchant-set custom.starting_price override instead of the
     real ₹0 variant price, which would parse as non-zero even though the
     actual variant that gets added to cart is ₹0. The real fix is
     data-pc-wish-price-cents, sourced directly from
     selected_or_first_available_variant.price in both card-product.liquid
     and sections/upk-pdp.liquid, the same numeric value /cart/add.js
     actually charges, so this text-parsing path only ever runs for legacy
     saved items lacking that field. */
  function priceTextLooksZero(text) {
    var digits = String(text || '').replace(/[^0-9]/g, '');
    return digits !== '' && parseInt(digits, 10) === 0;
  }

  /* Single source of truth for "can this saved item actually be purchased?".
     Prefers the authoritative numeric variant price (priceCents) whenever
     it's present; only falls back to parsing the display text for older
     items saved before this attribute existed. */
  function isPurchasable(it) {
    if (typeof it.priceCents === 'number' && !isNaN(it.priceCents)) {
      return it.priceCents > 0;
    }
    return !priceTextLooksZero(stripTags(it.price));
  }

  function priceFromCard(card) {
    var priceEl = card.querySelector('.pc-price');
    if (!priceEl) return '';
    var clone = priceEl.cloneNode(true);
    var s = clone.querySelector('s');
    if (s) s.remove();
    return stripTags(clone.textContent);
  }

  function itemFromButton(btn) {
    /* Explicit-attribute path: used by contexts that aren't a .pc / .card-wrapper
       product card, currently just the PDP heart (sections/upk-pdp.liquid),
       which renders its own data-pc-wish-title/-url/-image/-price/-variant so
       the exact product being viewed is captured without any DOM guessing.
       data-pc-wish-price-cents carries product.selected_or_first_available_variant.price
       the real numeric price of the exact variant data-pc-wish-variant points to. */
    if (btn.hasAttribute('data-pc-wish-title') || btn.hasAttribute('data-pc-wish-url')) {
      return {
        id: btn.getAttribute('data-pc-wish-id'),
        variantId: btn.getAttribute('data-pc-wish-variant') || '',
        title: btn.getAttribute('data-pc-wish-title') || '',
        url: btn.getAttribute('data-pc-wish-url') || '#',
        image: btn.getAttribute('data-pc-wish-image') || '',
        price: stripTags(btn.getAttribute('data-pc-wish-price') || ''),
        priceCents: parsePriceCents(btn.getAttribute('data-pc-wish-price-cents'))
      };
    }
    var card = btn.closest('.pc') || btn.closest('.card-wrapper');
    var wrapper = btn.closest('.card-wrapper') || btn.closest('.pc-card-wrapper') || card;
    if (!card) return null;
    var id = btn.getAttribute('data-pc-wish-id');
    var linkEl = card.querySelector('.pc-name a');
    var imgEl = card.querySelector('.pc-img img');
    return {
      id: id,
      variantId: wrapper ? wrapper.getAttribute('data-pc-vid') || '' : '',
      title: linkEl ? linkEl.textContent.trim() : '',
      url: linkEl ? linkEl.getAttribute('href') : '#',
      image: imgEl ? (imgEl.currentSrc || imgEl.getAttribute('src') || '') : '',
      /* Display text still comes from the card's rendered price (may show a
         merchant "from ₹X" override for Band+Charm Builder listings, that's
         fine for display). priceCents comes from data-pc-wish-price-cents on
         the same wrapper element as data-pc-vid, sourced in card-product.liquid
         from card_product.selected_or_first_available_variant.price, the
         real variant price, never the starting_price override, so it always
         matches what data-pc-vid would actually add to cart. */
      price: priceFromCard(card),
      priceCents: parsePriceCents(wrapper ? wrapper.getAttribute('data-pc-wish-price-cents') : null)
    };
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- cart actions shared by wishlist items + recently-viewed cards ---- */
  function cartAdd(variantId, btn, doneTxt) {
    if (!variantId || btn.disabled) return;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.status) { btn.textContent = 'Unavailable'; setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1500); return; }
      var dr = document.querySelector('cart-drawer');
      if (dr && d && d.sections && typeof dr.renderContents === 'function') dr.renderContents(d);
      btn.textContent = doneTxt || '\u2713 Added';
      setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1600);
    }).catch(function () { btn.disabled = false; btn.textContent = orig; });
  }
  function buyNow(variantId, btn) {
    if (!variantId || btn.disabled) return;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Processing\u2026';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.status) { btn.textContent = 'Unavailable'; setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1500); return; }
      // Verify the REAL cart total via /cart.js before allowing checkout, // never trust a locally-estimated total. Below the minimum order
      // value, send to /cart instead, where the existing minimum-order
      // message is already shown.
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r2) { return r2.json(); })
        .then(function (cart) {
          if (cart && cart.total_price >= UPK_MIN_ORDER_PAISE) {
            window.location.href = root + 'checkout';
          } else {
            try { sessionStorage.setItem('upkOpenCartOnLoad', '1'); } catch (e) {}
            window.location.href = root + 'cart';
          }
        })
        .catch(function () {
          // Couldn't verify the real total, fail safe to the cart rather
          // than risk sending an unverified order straight to checkout.
          window.location.href = root + 'cart';
        });
    }).catch(function () { btn.disabled = false; btn.textContent = orig; });
  }

  /* ---- wishlist item list ---- */
  function renderDrawer() {
    var listEl = document.querySelector('[data-upk-wish-list]');
    var countEl = document.querySelector('[data-upk-wish-drawer-count]');
    if (!listEl) return;
    var items = getList();
    if (countEl) countEl.textContent = '(' + items.length + ')';
    if (!items.length) {
      listEl.innerHTML = '<div class="upk-wish-empty"><p>Your wishlist is empty.</p><a href="/collections/all" class="upk-wish-empty__cta">Continue Shopping</a></div>';
      renderRecentlyViewed();
      return;
    }
    listEl.innerHTML = items.map(function (it) {
      var priceTxt = stripTags(it.price);
      var purchasable = isPurchasable(it);
      var actions = (it.variantId && purchasable)
        ? (
            '<button type="button" class="upk-wish-item__atc" data-upk-wish-atc="' + escapeHtml(it.variantId) + '">Add to bag</button>' +
            '<button type="button" class="upk-wish-item__buy" data-upk-wish-buy="' + escapeHtml(it.variantId) + '">Buy it now</button>'
          )
        : (!purchasable
            ? '<span class="upk-wish-item__unavail">Currently unavailable for purchase</span>'
            : ('<a class="upk-wish-item__view" href="' + escapeHtml(it.url) + '">View Product</a>')
          );
      return '<div class="upk-wish-item" data-upk-wish-item="' + escapeHtml(it.id) + '">' +
        '<a class="upk-wish-item__img" href="' + escapeHtml(it.url) + '">' +
          (it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="upk-wish-item__body">' +
          '<a class="upk-wish-item__title" href="' + escapeHtml(it.url) + '">' + escapeHtml(it.title) + '</a>' +
          (priceTxt ? '<span class="upk-wish-item__price">' + escapeHtml(priceTxt) + '</span>' : '') +
          '<div class="upk-wish-item__actions">' + actions + '</div>' +
        '</div>' +
        '<button type="button" class="upk-wish-item__remove" data-upk-wish-remove="' + escapeHtml(it.id) + '" aria-label="Remove from wishlist">&times;</button>' +
      '</div>';
    }).join('');
    renderRecentlyViewed();
  }

  /* ---- recently viewed rail (reads assets/upk-rails.js's 'upkRecent' key) ---- */
  function moneyFromPaise(paise) {
    if (paise == null) return '';
    var mf = window.__upkMFmt || '\u20B9{{amount}}';
    var s = (Math.round(paise) / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return stripTags(mf.replace(/\{\{\s*amount[^}]*\}\}/, s));
  }

  function renderRecentlyViewed() {
    var wrap = document.querySelector('[data-upk-wish-recent]');
    var track = document.querySelector('[data-upk-wish-recent-track]');
    if (!wrap || !track) return;
    var items = [];
    try { items = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) {}
    items = items.slice(0, 8);
    if (!items.length) { wrap.hidden = true; return; }
    track.innerHTML = items.map(function (p) {
      /* upk-rails.js already stores this rail's price as a real number
         (paise) when it can, so this path was already safe before today's
         fix, left exactly as is, per the "no other Wishlist functionality
         changes" instruction. */
      var priceTxt = typeof p.price === 'number' ? moneyFromPaise(p.price) : stripTags(p.price || '');
      var zero = typeof p.price === 'number' ? p.price <= 0 : priceTextLooksZero(priceTxt);
      var canAdd = !!p.variantId && !zero;
      return '<div class="upk-wish-recent-card">' +
        '<a class="upk-wish-recent-card__img" href="' + escapeHtml(p.url || '#') + '">' +
          (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<a class="upk-wish-recent-card__title" href="' + escapeHtml(p.url || '#') + '">' + escapeHtml(p.title || '') + '</a>' +
        (priceTxt ? '<span class="upk-wish-recent-card__price">' + escapeHtml(priceTxt) + '</span>' : '') +
        '<button type="button" class="upk-wish-recent-card__atc" data-upk-recent-atc="' + escapeHtml(p.variantId || '') + '"' + (canAdd ? '' : ' disabled') + '>Add to bag</button>' +
      '</div>';
    }).join('');
    wrap.hidden = false;
  }

  function openDrawer() {
    var d = document.querySelector('[data-upk-wish-drawer]');
    if (!d) return;
    renderDrawer();
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = document.querySelector('[data-upk-wish-drawer]');
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { d.hidden = true; }, 300);
  }

  /* Capture phase: fires before any bubble-phase card/navigation/quick-view
     listener can react to the same click, so a heart tap can never be
     swallowed or raced by something else on the card. */
  document.addEventListener('click', function (e) {
    var wishBtn = e.target.closest('[data-pc-wish-id]');
    if (wishBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var item = itemFromButton(wishBtn);
      if (item) {
        var willBeActive = !has(item.id);
        toggle(item);
        /* Belt-and-braces: flip the exact button tapped immediately, even if
           something elsewhere delays or interferes with the full sweep. */
        applyBtnState(wishBtn, willBeActive);
      }
      return;
    }

    if (e.target.closest('#upk-wishlist-toggle')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-upk-wish-close]')) { e.preventDefault(); closeDrawer(); return; }

    var removeTrig = e.target.closest('[data-upk-wish-remove]');
    if (removeTrig) { e.preventDefault(); remove(removeTrig.getAttribute('data-upk-wish-remove')); return; }

    var atcTrig = e.target.closest('[data-upk-wish-atc]');
    if (atcTrig) { e.preventDefault(); cartAdd(atcTrig.getAttribute('data-upk-wish-atc'), atcTrig); return; }

    var buyTrig = e.target.closest('[data-upk-wish-buy]');
    if (buyTrig) { e.preventDefault(); buyNow(buyTrig.getAttribute('data-upk-wish-buy'), buyTrig); return; }

    var recentAtc = e.target.closest('[data-upk-recent-atc]');
    if (recentAtc) { e.preventDefault(); cartAdd(recentAtc.getAttribute('data-upk-recent-atc'), recentAtc); return; }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Covers cards that load/re-render AFTER first paint (AJAX collection
     pagination, quick view, carousels) so their hearts reflect saved state
     the moment they appear, without waiting for another click anywhere. */
  function watchForNewCards() {
    if (!('MutationObserver' in window)) return;
    var scheduled = false;
    var mo = new MutationObserver(function (mutations) {
      if (scheduled) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-pc-wish-id]')) || (n.querySelector && n.querySelector('[data-pc-wish-id]'))) {
            scheduled = true;
            setTimeout(function () { scheduled = false; syncButtons(); syncBubble(); }, 30);
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function boot() { syncButtons(); syncBubble(); watchForNewCards(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function () { syncButtons(); syncBubble(); });

  window.upkWishlist = { add: add, remove: remove, toggle: toggle, has: has, count: count, getList: getList, open: openDrawer, close: closeDrawer };
})();
